<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png" /> -->
    <section><!-- <Carousel/> --></section>
    <section>
      <Intro
        data-aos="fade-down"
        data-aos-delay="600"
        data-aos-duration="1000"
      />
    </section>
    <section>
      <Budugunadeshana
        data-aos="zoom-in-up"
        data-aos-delay="800"
        data-aos-duration="800"
      />
    </section>
    <section class="section">
      <div>
        <div
          class="is-1"
          data-aos="fade-up"
          data-aos-delay="500"
          data-aos-duration="500"
        >
          <h2 class="title has-text-grey underline">ඉදිරි වැඩසටහන් පෙළගැස්ම</h2>
        </div>
        <!-- <div data-aos="fade-up" data-aos-delay="1000">Next program on Buddhist channel show up here or any notice</div> -->
        <div>
          <Timeline
            data-aos="fade-down"
            data-aos-delay="500"
            data-aos-duration="800"
          />
        </div>
      </div>
    </section>

    <div class="is-divider" data-content="අමාදොර" />

    <section class="section">
      <div class="columns button-link">
        <div
          v-for="(pb, index) in pageButtons"
          :key="index"
          class="column"
          data-aos="flip-right"
          data-aos-delay="500"
          data-aos-duration="800"
        >
          <div class="button is-dark">
            <router-link :to="pb.to">{{ pb.name }}</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- Map and  Address-->
    <section>
      <div
        class="columns"
        data-aos="fade-up"
        data-aos-delay="500"
        data-aos-duration="800"
      >
        <div class="column">
          <div
            class="cardStyle"
            data-aos="zoom-in-up"
            data-aos-delay="100"
            data-aos-duration="400"
          >
            <h5 class="title is-4 underline">ලිපිනය</h5>
            <p class>(ශ්‍රී කළ්‍යාණි යෝගාශ්‍රමානුබධ)</p>
            <p class="is-size-4">සීල සමාහිත යෝගාශ්‍රමය</p>
            <p class="is-size-5">සීලෝගම,</p>
            <p class="is-size-5">බෙලිහුල්ඔය,</p>
            <p class="is-size-5">ශ්‍රී ලංකාව</p>
          </div>
        </div>
        <div class="is-divider-vertical" data-content="අමාදොර" />
        <div clssName="column ">
          <div class="box mapouter">
            <div class>
              <div class="gmap_canvas">
                <iframe
                  title="unique"
                  width="800"
                  height="350"
                  id="gmap_canvas"
                  src="https://maps.google.com/maps?q=Seela%20Samahitha%20Yogasramaya&t=k&z=10&ie=UTF8&iwloc=&output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                />
                <a href="https://www.crocothemes.net" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
// import Carousel from "@/components/Carousel.vue";
import Intro from "@/components/Intro.vue";
import Timeline from "@/components/Timeline.vue";
import Budugunadeshana from "@/components/Budugunadeshana.vue";

export default {
  name: "home",
  components: {
    // Carousel,
    Intro,
    Timeline,
    Budugunadeshana
  },
  data() {
    return {
      pageButtons: [
        {
          to: "/video",
          name: "විඩියෝ දේශනා"
        },
        {
          to: "/audio",
          name: "ඕඩියෝ දේශනා"
        },
        {
          to: "/articles/vijam_bana",
          name: "ලිපි මාලාව"
        },
        {
          to: "/books",
          name: "දේශනා ග්‍රන්ථ"
        },
        {
          to: "/images",
          name: "සේයා රූ එකතුව"
        }
      ]
    };
  }
};
</script>

<style lang="sass" scoped>
.cardStyle
   background-color: "Orange";
   margin-top: 100px;

.mapouter
  margin: 25px;
  overflow: hidden;

.button
    transition: transform .2s; /* Animation */

.button:hover
      transform: scale(1.1);

.jumbo
  color: maroon
</style>
